import AnimatedCounter from "./AnimatedCounter";
function StatItem({ icon, value, suffix, label, isCounter }) {
  return (
    <div className="stat-item">
      <div className="stat-icon">{icon}</div>

      <div>
        <div className="stat-num">
          {isCounter ? <AnimatedCounter end={value} suffix={suffix} /> : value}
        </div>

        <div className="stat-label">{label}</div>
      </div>
    </div>
  );
}

export default StatItem;
